const LoadingSpinner = ({ message = "Loading..." }) => (
  <div className="w-full flex justify-center items-center py-10 ">
    <div className="text-center text-gray-500 animate-pulse">
      <svg
        className="animate-spin h-6 w-6 text-[#2F4B7C] mx-auto mb-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
      {message}
    </div>
  </div>
);
export default LoadingSpinner;